enum EUseSticker {
  USE = 'use',
  NOT_USE = 'not_use',
}

export default EUseSticker;
